import { render, staticRenderFns } from "./SearchTopics.vue?vue&type=template&id=08eba1fd&"
import script from "./SearchTopics.vue?vue&type=script&lang=js&"
export * from "./SearchTopics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports